<template>
  <nav v-if="totalPages > 0">
    <ul class="pagination pagination-sm pt-1">
      <li class="page-item" :class="{ 'disabled': disablePreviousButton }">
        <a class="page-link" href="javascript:void(0);" tabindex="-1" @click="previous">{{$lang.Common.DataTable.Previous}}</a>
      </li>
      <li
        class="page-item"
        v-for="page in totalPages"
        v-if="canShowPage(page)"
        :key="page"
        :class="{ 'disabled': page === currentPage }"
        @click="to(page)"
      >
        <a class="page-link" href="javascript:void(0)">
          {{ page }}
        </a>
      </li>
      <li class="page-item" :class="{ 'disabled': disableNextButton }">
        <a class="page-link" href="javascript:void(0);" @click="next">{{$lang.Common.DataTable.Next}}</a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'TablePager',
  props: {
    totalPages: {
      type: Number,
      required: false
    },
    value: {
      type: Number,
      required: true
    }
  },
  emits: [ 'update:value' ],
  model: {
    prop: 'value',
    event: 'update:value'
  },
  data () {
    return {
      local: {
        value: null
      }
    }
  },
  computed: {
    localValue: {
      get () {
        return this.local.value
      },
      set (value) {
        if (this.local.value !== value) {
          this.local.value = value
          this.$emit('update:value', value)
        }
      }
    },
    currentPage: {
      get () {
        return this.localValue + 1
      },
      set (value) {
        this.localValue = value - 1
      }
    },
    nextPage () {
      return this.currentPage + 1
    },
    disableNextButton: function () {
      return this.currentPage >= this.totalPages
    },
    disablePreviousButton: function () {
      return this.currentPage <= 1
    },
    previousPage () {
      return this.currentPage - 1
    }
  },
  watch: {
    value (newValue) {
      if (newValue !== this.localValue) {
        this.localValue = newValue
      }
    }
  },
  created () {
    this.local.value = this.value
  },
  methods: {
    canShowPage (page) {
      const firstPage = 1
      const lastPage = this.totalPages

      const offset = 2
      const currentPage = this.currentPage

      let nextOffset = currentPage + offset
      let previousOffset = currentPage - offset

      if (previousOffset < offset) nextOffset += offset - previousOffset
      if (nextOffset >= lastPage) previousOffset -= (nextOffset - lastPage) + 1

      if (page === firstPage || page === lastPage || page === currentPage) {
        return true
      } else if (page > currentPage && page <= nextOffset) {
        return true
      } else if (page < currentPage && page >= previousOffset) {
        return true
      }

      return false
    },
    next () {
      this.$emit('next')
    },
    previous () {
      this.$emit('previous')
    },
    to (page) {
      this.$emit('to', page)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/TablePager.vue